export default __webpack_public_path__ + "static/media/Q16_1_resized.0b28265b.jpg";